import { render, staticRenderFns } from "./commodityFlowStateComponent.vue?vue&type=template&id=93ffd4be&scoped=true&"
import script from "./commodityFlowStateComponent.vue?vue&type=script&lang=js&"
export * from "./commodityFlowStateComponent.vue?vue&type=script&lang=js&"
import style0 from "./commodityFlowStateComponent.vue?vue&type=style&index=0&id=93ffd4be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ffd4be",
  null
  
)

export default component.exports